import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { CardComponent } from './card.component';
import {SharedModule} from '../../../modules/shared.module';
import {EmptyDataModule} from '../empty-data/empty-data.module';
import {ErrorDataModule} from '../error-data/error-data.module';
import {PreloaderModule} from '../preloader/preloader.module';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import {IconsModule} from "../icons/icons.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};

@NgModule({
  declarations: [
    CardComponent,
  ],
  exports: [
    CardComponent,
  ],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    SharedModule,
    EmptyDataModule,
    ErrorDataModule,
    PreloaderModule,
    PortalModule,
    IconsModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class CardModule { }
